/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    11: '2.75rem',

    container: {
        sm: '320px',
        md: '768px',
        lg: '1200px',
        xl: '1440px',
        xxl: '1920px',
        xxxl: '2520px'
    }
}
